export const ADD_FAMILY_SUCCESS = 'add_family_ctn_success';

export const BLOCK_NUMBER_SUCCESS = 'block_ctn_success';
export const UNBLOCK_NUMBER_SUCCESS = 'unblock_ctn_success';

export const SERVICE_DISCONNECT_SUCCESS = 'ServiceDisconnectSuccess';

export const CARD_PAYMENT_SUCCESS = 'FinPaymentCardpayment';
